import { axiosPost } from "./ajaxServices";
import { urlGetSettings, urlSaveSettings } from "./CONSTANTS";

export const apiGetSettings = () => {
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  return new Promise((resolve, reject) => {
    axiosPost(urlGetSettings, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiSaveSettings = (settings) => {
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("settings", JSON.stringify(settings));
  return new Promise((resolve, reject) => {
    axiosPost(urlSaveSettings, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};
